import {
  ContentModules,
  Faqs,
  FaqsContentModule,
  Products,
  PageContent,
} from '@silvertours/common-landingpages-view';
import { Ui } from '@silvertours/front-shared';

const extractEmbeddedFaqs = (segment: ContentModules): Faqs => {
  if (segment.moduleType === 'textImage') {
    return Ui.extractEmbeddedFaqItems(segment.content);
  }

  if (segment.moduleType === 'standardContent') {
    return (segment.sections ?? []).flatMap(({ module }) =>
      module.moduleType === 'contentChunk'
        ? (module.chunks ?? []).flatMap(chunk =>
            Ui.extractEmbeddedFaqItems(chunk.body),
          )
        : [],
    );
  }

  if (segment.moduleType === 'tabs') {
    return segment.modules.flatMap(({ module }) =>
      module.moduleType === 'destination'
        ? Ui.extractEmbeddedFaqItems(module.content)
        : [],
    );
  }

  return [];
};

export const useStructuredData = (
  products: Products | null,
  page?: PageContent,
) => {
  if (!page || !('content' in page)) return { stations: [], faqs: undefined };

  const faqs =
    'article' in page.content
      ? page.content.article.segments
          .filter(segment => segment.moduleType === 'faqs')
          .flatMap(segment => (segment as FaqsContentModule).content)
          .concat(page.content.article.segments.flatMap(extractEmbeddedFaqs))
          .concat(
            'introduction' in page.content
              ? (page.content.introduction?.segments ?? []).flatMap(
                  extractEmbeddedFaqs,
                )
              : [],
          )
      : undefined;

  const author = 'author' in page.content ? page?.content?.author : [];

  const stations =
    'stationsMap' in page.content
      ? page?.content?.stationsMap?.content.stations
      : [];

  const supplierReviews =
    page.content.type !== 'plain' &&
    page.content.type !== 'minimal' &&
    'supplierReviews' in page.content
      ? page?.content?.supplierReviews?.content.supplierReviews
      : [];

  return {
    stations,
    supplierReviews,
    faqs,
    author,
    name: products?.name ?? '',
  };
};
